import React, { useState, useEffect } from 'react';
import './ConfirmationPage.scss';
import { useNavigate } from 'react-router-dom';
import { miniApp } from '@telegram-apps/sdk-react';
import { useCart } from '../../contexts/CartContext';
import Button from '../../components/ui/Button';

function ConfirmationPage() {
  const navigate = useNavigate();
  const {
            setIsCartOpen,
            setIsEnable,
            cartItems
          } = useCart();
  useEffect(() => {
      miniApp.setBackgroundColor('#161618');
      miniApp.setHeaderColor('#161618');
      setIsEnable(false);
    return () => {
      miniApp.setBackgroundColor('#1D1D20');
      miniApp.setHeaderColor('#1D1D20');
      setIsEnable(true);
    };
  }, []);

  return (
    <div className="confirmation-page">
      <div className="icon-check">
        <svg width="32" height="32" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M20.7096 6.29536C21.0987 6.68724 21.0965 7.32041 20.7046 7.70957L9.62772 18.7096C9.23776 19.0968 8.60839 19.0968 8.21844 18.7096L3.29536 13.8207C2.90348 13.4315 2.90127 12.7984 3.29043 12.4065C3.67959 12.0146 4.31276 12.0124 4.70464 12.4015L8.92308 16.5907L19.2954 6.29043C19.6872 5.90127 20.3204 5.90348 20.7096 6.29536Z" fill="white"/>
</svg>
      </div>
      <h2 className="title">Заявка на просчет принята</h2>
      <div className="subtitle">
        Ожидайте в течение 2-х часов товар появится в списке
      </div>
      <div className='two-btn-container'>
        <Button className="btn-secondary large" onClick={() => navigate('/request')}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M12 5C12.5523 5 13 5.44772 13 6V11H18C18.5523 11 19 11.4477 19 12C19 12.5523 18.5523 13 18 13H13V18C13 18.5523 12.5523 19 12 19C11.4477 19 11 18.5523 11 18V13H6C5.44772 13 5 12.5523 5 12C5 11.4477 5.44772 11 6 11H11V6C11 5.44772 11.4477 5 12 5Z" fill="white"/>
</svg>
Добавить
        </Button>
        <Button className="btn-primary large" onClick={() => navigate('/')}>
          Понятно
        </Button>
      </div>
      
    </div>
  );
}

export default ConfirmationPage;
